import React from "react";
import CrudEditor from "./admin/CrudEditor";

const ICONS = ["code", "users", "book-open", "globe", "layers", "smartphone", "briefcase"];

export default function AdminServices() {
  return (
    <CrudEditor
      title="Services"
      subtitle="Add, edit, and reorder the services shown on your site."
      endpoint="/services"
      testKey="services"
      emptyItem={{ title: "", tagline: "", description: "", icon: "code", features: [], order: 0 }}
      fields={[
        { key: "title", label: "Title", type: "text" },
        { key: "tagline", label: "Tagline", type: "text" },
        { key: "description", label: "Description", type: "textarea" },
        { key: "icon", label: `Icon key (${ICONS.join(", ")})`, type: "text", placeholder: "code" },
        { key: "features", label: "Features (one per line)", type: "list" },
        { key: "order", label: "Display order", type: "number" },
      ]}
    />
  );
}
